import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { LocationsRepository } from "../../repositories";
import { Observable } from 'rxjs';
import { Location } from "../../domain";

@Injectable({ providedIn: 'root' })
export class GetLocationsByPlanIdUsecase implements UseCase<string, Location[]> {

  constructor(private locationRepository: LocationsRepository) {
  }

  execute(params: string): Observable<Location[]> {
    return this.locationRepository.getLocationsByPlanId(params);
  }

}